export default function Story() {
  return (
    <section id="story" className="py-20">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-serif mb-6">
          From Farms to Global Markets
        </h2>
        <p className="text-gray-600">
          Pure Spices from Nature’s Heart
At Kaaliglobal, we bring you the finest Cardamom and Black Pepper, carefully sourced from the best farms of South India.
We believe in quality, purity, and global trust — delivering spices that meet international export standards.
        </p>
      </div>
    </section>
  );
}
